import { useQuery } from 'react-query'
import { removeDefaultParams } from 'src/common/utils'

import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'
import { mediaListService } from 'src/services/media-list.service'

export const initialMediaListParams = {
  query: '',
  media_type: ['all'],
  connection_type: ['all'],
}

export const useMediaList = (params?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.MEDIA_LIST, params],
    () => mediaListService.getMedia(removeDefaultParams(params, initialMediaListParams)),
    {
      keepPreviousData: true,
    },
  )
}
